// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.using-keyboard .heading[data-v-28edc129]:focus{box-shadow:0 0 0 0}body.using-keyboard .heading:focus .checkbox-container[data-v-28edc129]{border-radius:8px;box-shadow:0 0 0 2px rgba(0,132,255,.3019607843)}", ""]);
// Exports
module.exports = exports;
